<script setup lang="ts">
import EditDwMsgDrawer from '@/pages/erp/dw/msg/view/dw-msg-drawer.vue'
import type { DwMsgProperties } from '@/pages/erp/dw/msg/db/dw-msg-types'
import Swal from 'sweetalert2'
definePage({
    meta: {
        action: 'manage',
        subject: 'DWMSG',
    },
})

const compId = ref(useStorage('compNo').value)
const userId = ref()
const createTime = ref()
const keyFieldName = ref()
const workItemState = ref()

// Data table options
const currentPage = ref(1)
const size = ref(10)
const sortOrder = ref()
const orderByCol = ref()

// Update data table options
const updateOptions = (options: any) => {
  sortOrder.value = options.sortBy[0]?.key
  orderByCol.value = options.sortBy[0]?.order
}

// Headers

const grid1Headers = [
    { title: '使用者代號', key: 'userId' },
    { title: '訊息序號', key: 'serNo' },
    { title: '活動名稱', key: 'activityName' },
    { title: '訊息型態', key: 'keyFieldName' },
    { title: '訊息狀態', key: 'workItemState' },
    { title: '發送者', key: 'creatorName' },
    { title: '發送時間', key: 'createTime' },
    { title: '完成時間', key: 'completeTime' },
    { title: '操作', key: 'actions', sortable: false}
]


// champ 後端分頁是從 0 開始
const page = computed((): number => currentPage.value - 1)

// 👉 Fetching users
const { data: dwMsgsData, execute: fetchDwMsgs } = await useApi<any>(createUrl('/dw/msg/msg/searchDwMsg', {
  query: {
    compId,
    userId,
    createTime,
    keyFieldName,
    workItemState,
    page,
    size,
    orderByCol,
    sortOrder,
  },
}))

const datas = computed((): DwMsgProperties[] => dwMsgsData.value.data.dwMsgPage.content)
const totalDatas = computed(() => dwMsgsData.value.data.dwMsgPage.totalElements)

console.log('datas: ', datas)

const isEditDataDrawerVisible = ref(false)
const isNewData = ref(false)
const isCopyData = ref(false)

let voData = {}


const createData = () => {
  isEditDataDrawerVisible.value = true
  isNewData.value = true
  isCopyData.value = false
}

const editData = (dwMsgData: DwMsgProperties) => {
  voData = dwMsgData
  console.log('editDwMsg: ', voData)
  isEditDataDrawerVisible.value = true
  isNewData.value = false
  isCopyData.value = false
}

const copyData = (dwMsgData: DwMsgProperties) => {
    voData = dwMsgData
    console.log('copyDwMsg: ', voData)
    isEditDataDrawerVisible.value = true
    isNewData.value = true
    isCopyData.value = true
}

// 👉 Add new data
const addNewData = async (dwMsgData: DwMsgProperties) => {
  await $api('/dw/msg/msg/createDwMsg', {
    method: 'POST',
    body: { dwMsg: dwMsgData },
  }).then(() => {
      $swal({
      position: 'top-end',
      icon: 'success',
      title: '新增成功',
      showConfirmButton: false,
      timer: 1500,
      customClass: {
        confirmButton: 'btn btn-primary',
      },
      buttonsStyling: false,
    })
  })

  // refetch data
  fetchDwMsgs()
}

const updateData = async (dwMsgData: DwMsgProperties) => {
  await $api('/dw/msg/msg/updateDwMsg', {
    method: 'PUT',
    body: { dwMsg: dwMsgData },
  }).then(() => {
      $swal({
      position: 'top-end',
      icon: 'success',
      title: '修改成功',
      showConfirmButton: false,
      timer: 1500,
      customClass: {
        confirmButton: 'btn btn-primary',
      },
      buttonsStyling: false,
    })
  })

  // refetch data
  fetchDwMsgs()
}

  // 👉 Delete data
const deleteData = async (dwMsgData: DwMsgProperties) => {
  const { userId,processId,serNo,activityId } = dwMsgData
    $swal({
    title: `確定要刪除 ${dwMsgData.activityId} 資料?`,
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "確定",
    cancelButtonText: "取消"
  }).then((result) => {
    if (result.isConfirmed) {
        $api(`/dw/msg/msg/deleteDwMsg`, {
        method: 'DELETE',
        query: {
          userId,processId,serNo,activityId
        }
      }).then(() => {
          $swal({
          position: 'top-end',
          title: "刪除成功",
          timer: 1500,
          icon: "success"
        });

        // refetch Data
        fetchDwMsgs()
      })
    }
  });

}

const clickRow = (event, select) => {
  console.log('clickRow: ', event, select)
  editData(select.item)
}

</script>

<template>
  <!-- 👉 Widgets -->

  <VCard class="mb-6">
    <VCardItem class="pb-2 pt-2">
      <VCardTitle>搜尋</VCardTitle>
    </VCardItem>

    <VCardText>
      <VRow>
        <VCol
         cols="12"
         sm="2"
        >
          <AppTextField
            v-model="compId"
            clearable
            clear-icon="mdi-close-circle"
            placeholder="請輸入公司別"
          />
        </VCol>
        <VCol
         cols="12"
         sm="2"
        >
          <AppTextField
            v-model="userId"
            clearable
            clear-icon="mdi-close-circle"
            placeholder="請輸入使用者代號"
          />
        </VCol>
        <VCol
         cols="12"
         sm="2"
        >
          <AppTextField
            v-model="createTime"
            clearable
            clear-icon="mdi-close-circle"
            placeholder="請輸入發送時間"
          />
        </VCol>
        <VCol
         cols="12"
         sm="2"
        >
          <AppTextField
            v-model="keyFieldName"
            clearable
            clear-icon="mdi-close-circle"
            placeholder="請輸入訊息型態"
          />
        </VCol>
        <VCol
         cols="12"
         sm="2"
        >
          <AppTextField
            v-model="workItemState"
            clearable
            clear-icon="mdi-close-circle"
            placeholder="請輸入訊息狀態"
          />
        </VCol>
      </VRow>
    </VCardText>

    <VDivider />

    <VCardText class="d-flex flex-wrap gap-4">
      <VSpacer />

      <div class="app-user-search-filter d-flex align-center flex-wrap gap-4">
        <!-- 👉 Add button -->
        <VBtn
                prepend-icon="tabler-plus"
                @click="createData"
        >
          新增訊息通知
        </VBtn>
      </div>
    </VCardText>

    <VDivider />

    <!-- SECTION datatable -->
    <VDataTableServer
            v-model:items-per-page="size"
            v-model:page="currentPage"
            :items="datas"
            :items-length="totalDatas"
            :headers="grid1Headers"
            class="text-no-wrap"
            @update:options="updateOptions"
    >

      <template #item.userId="{ item }">
          <div class="text-body-1 text-high-emphasis">
              {{ item.userId }}
          </div>
      </template>

      <template #item.serNo="{ item }">
          <div class="text-body-1 text-high-emphasis">
              {{ item.serNo }}
          </div>
      </template>

      <template #item.activityName="{ item }">
          <div class="text-body-1 text-high-emphasis">
              {{ item.activityName }}
          </div>
      </template>

      <template #item.keyFieldName="{ item }">
          <div class="text-body-1 text-high-emphasis">
              {{ item.keyFieldName }}
          </div>
      </template>

      <template #item.workItemState="{ item }">
          <div class="text-body-1 text-high-emphasis">
              {{ item.workItemState }}
          </div>
      </template>

      <template #item.creatorName="{ item }">
          <div class="text-body-1 text-high-emphasis">
              {{ item.creatorName }}
          </div>
      </template>

      <template #item.createTime="{ item }">
          <div class="text-body-1 text-high-emphasis">
              {{ item.createTime }}
          </div>
      </template>

      <template #item.completeTime="{ item }">
          <div class="text-body-1 text-high-emphasis">
              {{ item.completeTime }}
          </div>
      </template>

      <!-- Actions -->
      <template #item.actions="{ item }">
          <IconBtn @click="editData(item)">
              <VIcon icon="tabler-edit" />
              <v-tooltip
                      activator="parent"
                      location="bottom"
              >編輯</v-tooltip>
          </IconBtn>
          <IconBtn @click="copyData(item)">
              <VIcon icon="tabler-copy" />
              <v-tooltip
                      activator="parent"
                      location="bottom"
              >複製</v-tooltip>
          </IconBtn>
          <IconBtn @click="deleteData(item)">
              <VIcon icon="tabler-trash" />
              <v-tooltip
                      activator="parent"
                      location="bottom"
              >刪除</v-tooltip>
          </IconBtn>
      </template>

      <!-- pagination -->
      <template #bottom>
        <TablePagination
                v-model:page="currentPage"
                v-model:size="size"
                :items-per-page="size"
                :total-items="totalDatas"
        />
      </template>
    </VDataTableServer>
    <!-- SECTION -->
  </VCard>
  <!-- 👉 Edit -->
  <EditDwMsgDrawer
          v-model:isDrawerOpen="isEditDataDrawerVisible"
          :dwMsg-data="voData"
          :is-new="isNewData"
          :is-copy="isCopyData"
          @create-data="addNewData"
          @update-data="updateData"
  />

</template>
